import React from 'react';
import  Visittobagyalakshmifarm2024  from 'views/Visittobagyalakshmifarm2024';

const VissionAndMissionPage = () => {
  return <Visittobagyalakshmifarm2024/>;
};

export default VissionAndMissionPage;